import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db } from "../firebaseConfig";
import Comments from "./Comments";

import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  limit
} from "firebase/firestore";

import { FaCalendarAlt, FaClock } from "react-icons/fa";
import "./MobileNewsDetails.css";

const MobileNewsDetails = () => {
  const { id } = useParams();
  const [openedIds, setOpenedIds] = useState([]);
  const [openedNews, setOpenedNews] = useState([]);
  const [news, setNews] = useState(null);
  const [relatedNews, setRelatedNews] = useState([]);
  
  useEffect(() => {
  const fetchNews = async () => {
    const docRef = doc(db, "news", id);
    const snap = await getDoc(docRef);

    if (snap.exists()) {
      const data = { id: snap.id, ...snap.data() };

      setOpenedNews((prev) => {
        const exists = prev.find(n => n.id === id);
        if (exists) return prev;
        return [...prev, data]; // 🔥 IMPORTANT: append
      });

      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  fetchNews();
}, [id]);
  
 

// সব useEffect ডিলিট করে শুধু এই একটি রাখুন
useEffect(() => {
  const fetchAllData = async () => {
    const docRef = doc(db, "news", id);
    const snap = await getDoc(docRef);

    if (snap.exists()) {
      const newsData = { id: snap.id, ...snap.data() };
      setNews(newsData);

      // Related news
      const q = query(
        collection(db, "news"),
        where("category", "==", newsData.category),
        limit(6)
      );

      const querySnapshot = await getDocs(q);
      const related = querySnapshot.docs
        .filter(doc => doc.id !== id)
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .slice(0, 5);

      setRelatedNews(related);
      window.scrollTo(0, 0);
    }
  };

  fetchAllData();
}, [id]);


  if (!news) {
    return (
      <div className="mobile-news-loading">
        লোড হচ্ছে...
      </div>
    );
  }


  return (
    <div className="mobile-news-details">

      <h1 className="mobile-news-title">
        {news.title}
      </h1>

      <div className="mobile-reporter">
        প্রতিবেদক:
        <span>
          {news.reporterName || "নিজস্ব প্রতিবেদক"}
        </span>
      </div>

      <div className="mobile-news-meta">

        <span>
          <FaCalendarAlt />
          {news.timestamp
            ? new Date(
                news.timestamp.seconds * 1000
              ).toLocaleDateString(
                "bn-BD",
                {
                  day: "2-digit",
                  month: "long",
                  year: "numeric"
                }
              )
            : "তারিখ নেই"}
        </span>

        <span>
          <FaClock />
          {news.timestamp
            ? new Date(
                news.timestamp.seconds * 1000
              ).toLocaleTimeString(
                "bn-BD",
                {
                  hour: "2-digit",
                  minute: "2-digit"
                }
              )
            : "সময় নেই"}
        </span>

      </div>

      <img
        src={news.image}
        alt={news.title}
        className="mobile-news-image"
      />

      {news.caption && (
        <p className="mobile-caption">
          {news.caption}
        </p>
      )}

   <div className="mobile-news-content">
  {news.content.split('\n').map((paragraph, index) => (
    paragraph.trim() !== "" ? (
      <p key={index} style={{ textAlign: "justify", lineHeight: "1.8", marginBottom: "20px" }}>
        {paragraph}
      </p>
    ) : null
  ))}
</div>


{news.tags && news.tags.length > 0 && (
  <div
    style={{
      marginTop: "25px",
      marginBottom: "30px",
      paddingTop: "15px",
      borderTop: "1px solid #ddd",
    }}
  >
    <strong style={{ display: "block", marginBottom: "12px" }}>
      কী-ওয়ার্ড
    </strong>

    {news.tags.map((tag, index) => (
      <Link
        key={index}
        to={`/tag/${encodeURIComponent(tag)}`}
        style={{
          display: "inline-block",
          marginRight: "8px",
          marginBottom: "8px",
          padding: "7px 12px",
          background: "#f3f3f3",
          color: "#333",
          textDecoration: "none",
          borderRadius: "18px",
          fontSize: "14px",
        }}
      >
        {tag}
      </Link>
    ))}
  </div>
)}

<Comments newsId={news.id} />

      <div className="mobile-related-section">
  {relatedNews.map(item => (
    <div key={item.id} className="mobile-related-card" style={{ marginBottom: '40px', borderBottom: '1px solid #eee' }}>
      
      {/* শিরোনাম */}
      <h3 style={{ fontSize: '22px', marginBottom: '15px', color: '#000' }}>
        {item.title}
      </h3>

      {/* ইমেজ */}
      <img
        src={item.image}
        alt={item.title}
        style={{ width: '100%', borderRadius: '8px', marginBottom: '15px' }}
      />

      {/* কন্টেন্ট (পুরোপুরি ওপেন) */}
      <div className="mobile-news-content">
        {item.content?.split('\n').map((paragraph, index) => (
          paragraph.trim() !== "" ? (
            <p key={index} style={{ 
              textAlign: "justify", 
              lineHeight: "1.8", 
              marginBottom: "20px", 
              fontSize: '17px', 
              color: '#333' 
            }}>
              {paragraph}
            </p>
          ) : null
        ))}
      </div>
	  
<Comments newsId={item.id} />

    </div>
  ))}
</div>

    </div>
  );
};

export default MobileNewsDetails;